const TMDB_API_OPTION = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJhZDM2OTI5ODAyNGNjYmRhMTMzM2ViYTIyODk3OGZlMCIsIm5iZiI6MTcxOTE0NDMwOC45NTI1NTUsInN1YiI6IjY2NzgwZGMzOTdkMDQ3YWNlNTNiMWJiZSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.WMpgnutQFvVhzCohY5tRRM5GHzYXRHHrl4a_ykr3oP8`,
  },
};
export default TMDB_API_OPTION
